import { useMutation, useQueryClient } from 'react-query';

import { resendDocumentRoute } from '@features/digitalOnboarding';
import axiosInstance from '@server/axiosInstance';
import { applicationDocsKey } from '@features/applicationsDocs';
import { Dispatch, SetStateAction } from 'react';
import { errorMessage } from '@features/applicationQuestions';

type useResendDocumentProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useResendDocument = ({
  setErrorText,
}: useResendDocumentProps) => {
   const signedTemplatesKey = 'signedTemplates';
  const client = useQueryClient();
  const { mutate: sendDocument, isLoading: isSendingDocument } = useMutation({
    mutationFn: (variables: { application_id: number; template_id?: number, template_ids?: number[] }) =>
      axiosInstance
        .post(resendDocumentRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(applicationDocsKey);
        client.invalidateQueries(signedTemplatesKey);
        if (setErrorText) {
          setErrorText('');
        }
      } else {
        if (setErrorText) {
          setErrorText(data?.message || errorMessage);
        }
      }
    },
  });

  return {
    sendDocument,
    isSendingDocument,
  };
};
